const DEFAULT_ADULTS_COUNT = 1;
const DEFAULT_INFANTS_COUNT = 0;
const DEFAULT_CHILDREN_COUNT = 0;

export function makeGuestsValid(guests = {}) {
  return {
    adults: toValid(guests?.adults, DEFAULT_ADULTS_COUNT),
    infants: toValid(guests?.infants, DEFAULT_INFANTS_COUNT),
    children: toValid(guests?.children, DEFAULT_CHILDREN_COUNT),
  };

  /**
   * @returns {number} Valid value
   **/
  function toValid(count, min) {
    return Math.max(Number(count) || 0, min);
  }
}

export function makeGuestsValidWithLimit(guests, limit) {
  guests = makeGuestsValid(guests);
  if (!limit || limit < 1) limit = Number.POSITIVE_INFINITY;
  while (limit < guests.adults + guests.children) {
    if (guests.children > 0) guests.children--;
    else if (guests.adults > 0) guests.adults--;
    else break;
  }
  return guests;
}

export function getDefaultGuests() {
  return {
    adults: DEFAULT_ADULTS_COUNT,
    infants: DEFAULT_INFANTS_COUNT,
    children: DEFAULT_CHILDREN_COUNT,
  };
}

export const getGuestsQuery = (query) => {
  const guests = makeGuestsValid(query);
  return Object.keys(guests).reduce((acc, key) => {
    if (guests[key]) acc[key] = guests[key];
    return acc;
  }, {});
};

const DEFAULT_BEDS_COUNT = 0;
const DEFAULT_BEDROOMS_COUNT = 0;
const DEFAULT_BATHROOMS_COUNT = 0;

export function makeRoomsValid(rooms = {}) {
  return {
    bedrooms: toValid(rooms?.bedrooms, DEFAULT_BEDROOMS_COUNT),
    bathrooms: toValid(rooms?.bathrooms, DEFAULT_BATHROOMS_COUNT),
    beds: toValid(rooms?.beds, DEFAULT_BEDS_COUNT),
  };

  /**
   * @returns {number} Valid value
   **/
  function toValid(count, min) {
    return Math.max(Number(count) || 0, min);
  }
}

export function makeRatingValid(rating = null) {
  return rating === null ? rating : Number(rating) || 0;
}

export function getDefaultRooms() {
  return {
    bedrooms: DEFAULT_BEDROOMS_COUNT,
    bathrooms: DEFAULT_BATHROOMS_COUNT,
    beds: DEFAULT_BEDS_COUNT,
  };
}
